<template>
  <div>
    <div>
      <b-table
        ref="table"
        striped
        :items="listKpi"
        :fields="fields"
        @change="$refs.table.refresh()"
      >
        <template #cell(kpiType)="{ index }">
          <b-form-group>
            <custom-select
              class="bg-white"
              v-model="listKpi[index].kpiType"
              :options="KpiType.filters"
              @change="$refs.table.refresh()"
              placeholder="Select Key Performance Indicator"
            />
          </b-form-group>
        </template>
        <template #cell(weight)="{ index }">
          <b-form-group>
            <b-form-input class="text-center" type="number" v-model="listKpi[index].weight"></b-form-input>
          </b-form-group>
        </template>
        <template #cell(target)="{ index }">
          <b-form-group>
            <b-form-input class="text-center" type="number" v-model="listKpi[index].target"></b-form-input>
          </b-form-group>
        </template>
        <template #cell(realization)="{ index }">
          <b-form-group>
            <b-form-input class="text-center" type="number" v-model="listKpi[index].realization"></b-form-input>
          </b-form-group>
        </template>
        <template #cell(score)="{ index }">
          <b-form-group>
            <b-form-input
              class="text-center vertical-baseline bg-white"
              type="number"
              v-model="listKpi[index].score"
              @change="$refs.table.refresh()"
            >
            </b-form-input>
          </b-form-group>
        </template>
        <template #cell(finalScore)="{ index }">
          <b-form-group>
            <b-form-input
              class="text-center vertical-baseline bg-white"
              type="number"
              v-model="listKpi[index].finalScore"
              @change="$refs.table.refresh()"
            >
            </b-form-input>
          </b-form-group>
        </template>
        <template #cell(action)="{ index }">
          <div>
            <b-button variant="warning" @click="removeKpi(index, listKpi[index].kpi)">
              <b-icon icon="dash" variant="white"></b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <div class="btn-confirm-data-kpi">
      <b-button class="text-white" variant="warning" @click="sendDataToParent" :disabled="kpiIsNull">
        Confirm
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    kpi: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      optionKpiType: ['Minimum'],
      KpiType: {
        show: true,
        filters: [
          'Maximize',
          'Minimize'
        ]
      },
      listKpi: [],
      fields: [
        { key: 'kpi', label: 'KPI', thClass: 'text-center', tdClass: 'text-center vertical-baseline' },
        { key: 'kpiType', label: 'KPI Type', thClass: 'text-center', tdClass: 'text-center vertical-baseline' },
        { key: 'weight', label: 'Weight', thClass: 'text-center', tdClass: 'text-center vertical-baseline' },
        { key: 'target', label: 'Target', thClass: 'text-center', tdClass: 'text-center vertical-baseline' },
        { key: 'realization', label: 'Realization', thClass: 'text-center', tdClass: 'text-center vertical-baseline' },
        { key: 'score', label: 'Score', thClass: 'text-center', tdClass: 'text-center vertical-baseline' },
        { key: 'finalScore', label: 'Final Score', thClass: 'text-center', tdClass: 'text-center vertical-baseline' },
        { key: 'action', label: 'Action', thClass: 'text-center', tdClass: 'text-center vertical-baseline' }
      ],
      constVariantKpi: [
        'FUNCTIONALITY',
        'BUGFOUND',
        'BUGRESOLVED',
        'ISSUEOFPRODUCT',
        'USERMANUAL',
        'CARRYOVER',
        'DESIGN',
        'REVISI DESIGN',
        'TEPATWAKTU',
        'LOGBOOK',
        'TRAININGHARDSKILL&SOFT SKILL',
        'HELPINGOTHERS'
      ],
      kpiIsNull: true,
      targetRemove: {
        index: 0,
        targetKpi: ''
      },
      initValue: 0
    }
  },
  methods: {
    calculateScoreKpi(kpi, target, realization) {
      const nameKPI = kpi.replaceAll(' ', '')
      if (!isNaN(target) && !isNaN(realization) && target !== 0) {
        if (nameKPI.toUpperCase() === this.constVariantKpi[0]) { // Functionality
          return ((realization / target) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[1]) { // Bug Found
          const result = ((target / realization) * 100).toFixed(2)
          if (result <= 125) {
            return 0
          } else if (result >= 126 && result <= 170) {
            return 30
          } else if (result >= 171 && result <= 250) {
            return 50
          } else if (result >= 251) {
            return 80
          } else if (result >= 360) {
            return 100
          }
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[2]) { // Bug Resolved
          return ((realization / target) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[3]) { // Issue of Product
          return ((target / realization) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[4]) { // User Manual
          return ((realization / target) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[5]) { // Carry Over
          const result = ((target / realization) * 100).toFixed(2)
          if (result <= 125) {
            return 0
          } else if (result >= 126 && result <= 170) {
            return 30
          } else if (result >= 171 && result <= 250) {
            return 50
          } else if (result >= 251) {
            return 80
          } else if (result >= 360) {
            return 100
          }
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[6]) { // Design
          return ((realization / target) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[7]) { // Revisi Design
          return ((target / realization) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[8]) { // Tepat Waktu
          return ((realization / target) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[9]) { // Logbook
          return ((realization / target) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[10]) { // Training Hardskill & Softskill
          return ((realization / target) * 100).toFixed(2)
        } else if (nameKPI.toUpperCase() === this.constVariantKpi[11]) { // Helping Others
          return ((target / realization) * 100).toFixed(2)
        }
      } else {
        return NaN
      }
    },
    sendDataToParent() {
      this.$emit('data', this.listKpi)
      this.$emit('button', this.btnActive)
    },
    removeKpi(index, nameKpi) {
      this.targetRemove.index = index
      this.targetRemove.targetKpi = nameKpi
      this.listKpi.splice(index, 1)
      this.kpi.splice(index, 1)
      this.$emit('remove', this.targetRemove)
      this.$refs.table.refresh()
    }
  },
  watch: {
    listKpi: {
      handler(newValues) {
        let score = 0
        for (const item of newValues) {
          item.weight = parseInt(item.weight)
          item.target = parseInt(item.target)
          item.realization = parseInt(item.realization)
          score = parseInt(this.calculateScoreKpi(item.kpi, item.target, item.realization))
          if (isNaN(score)) {
            item.score = parseInt(item.score)
            item.finalScore = parseInt(item.finalScore)
          } else {
            item.score = score !== 0 ? score : parseInt(item.score)
            item.finalScore = score !== 0 ? (item.score / 100) * item.weight : parseInt(item.finalScore)
          }
        }
      },
      deep: true
    },
    kpi: {
      handler() {
        this.listKpi = []
        this.kpi.forEach((item, i) => {
          this.listKpi.push({
            kpi: item.kpi,
            idObjective: item.idObjective,
            kpiType: item.kpiType,
            weight: parseInt(item.weight),
            target: parseInt(item.target),
            realization: parseInt(item.realization),
            score: parseInt(this.initValue),
            finalScore: parseInt(this.initValue),
            _rowVariant: i % 2 === 0 ? 'warning' : ''
          })
        })
        if (this.listKpi.length !== 0) {
          this.kpiIsNull = false
        } else {
          this.kpiIsNull = true
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-confirm-data-kpi{
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
